import styled from 'styled-components'

export const FormContentWrapper = styled.div`
  padding-left: 8px;
  min-height: 45vh;
`
